import { http } from 'utils'

import {
  OrdersDetailsWestfieldConsAPITypes,
  OrdersDetailsWestfieldConsFetchParamsTypes,
} from 'types/orders-details-westfieldcons'
import { OrdersDetailsWestfieldConsAPISchemas } from 'schemas/orders-details-westfieldcons-schemas'

import { DATASTATUS } from 'constants/status'

export async function postOrdersDetailsWestfieldConsAPI({
  orderId,
}: OrdersDetailsWestfieldConsFetchParamsTypes): Promise<OrdersDetailsWestfieldConsAPITypes> {
  const url = `/orders/consumer/${orderId}`

  const response = await http.get<unknown>(url)
  const validatedData = OrdersDetailsWestfieldConsAPISchemas.safeParse(
    response.data
  )

  console.log(validatedData.error, ' ERROR')

  if (!validatedData.success) {
    return {
      data: null,
      outcomeMessage: JSON.stringify(validatedData.error),
      ...DATASTATUS,
    }
  }
  return validatedData.data
}
